import { ComponentPlugin } from './component.plugin';
export class FunctionalComponentPlugin extends ComponentPlugin {
    createComponent(component, provision) {
        return component.tag.apply(provision, [component.props, this.renderer(), component.children]);
    }
    match(component) {
        return typeof component.tag === 'function';
    }
    priority() {
        return ComponentPlugin.PriorityFallback;
    }
}
//# sourceMappingURL=func-comp.plugin.js.map